import { jsx as _jsx } from "react/jsx-runtime";
import * as React from 'react';
import { cn } from '../lib/cn.js';
export const Textarea = React.forwardRef(({ className, autoGrow, onChange, ...props }, ref) => {
    const innerRef = React.useRef(null);
    const setRef = (node) => {
        innerRef.current = node;
        if (typeof ref === 'function')
            ref(node);
        else if (ref)
            ref.current = node;
    };
    const resize = React.useCallback(() => {
        const el = innerRef.current;
        if (!el || !autoGrow)
            return;
        el.style.height = 'auto';
        el.style.height = `${el.scrollHeight}px`;
    }, [autoGrow]);
    React.useEffect(() => {
        if (autoGrow)
            resize();
    }, [autoGrow, resize]);
    return (_jsx("textarea", { ref: setRef, onChange: (e) => {
            onChange?.(e);
            if (autoGrow)
                resize();
        }, className: cn('min-h-20 w-full rounded-[var(--radius-2)] border border-[var(--color-border-default)] bg-[var(--color-surface-canvas)] px-3 py-2 text-sm text-[var(--color-text-primary)] placeholder:text-[var(--color-text-muted)] focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[var(--color-border-focus)] disabled:cursor-not-allowed disabled:opacity-50', className), ...props }));
});
Textarea.displayName = 'Textarea';
//# sourceMappingURL=textarea.js.map